import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { PhoneIcon } from 'lucide-react';
export function BookingCTA() {
  return <section className="py-8 md:py-24 bg-jet relative border-y border-burgundy/20" data-id="element-75">
      <div className="absolute inset-0 pattern-dots opacity-20" data-id="element-76"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border border-burgundy/30 p-8 md:p-16 rounded-sm bg-jet/80 backdrop-blur-md relative overflow-hidden" data-id="element-78">
          {/* Corner ornaments */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-burgundy m-4" data-id="element-79"></div>
          <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-burgundy m-4" data-id="element-80"></div>
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-burgundy m-4" data-id="element-81"></div>
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-burgundy m-4" data-id="element-82"></div>

          <h2 className="text-4xl md:text-6xl font-heading font-bold text-cream mb-6 text-glow" data-id="element-83">
            Ready to Transform Your Look?
          </h2>

          <p className="text-cream/70 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-84">
            Secure your spot today. Our calendar fills up quickly, and we'd love
            to craft your next protective style.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-85">
            <a href="tel:3013858034" data-id="element-86">
              <Button variant="primary" size="lg" className="text-lg px-12" data-id="element-87">
                <PhoneIcon className="w-5 h-5 mr-2" data-id="element-88" />
                Call Now — 301-385-8034
              </Button>
            </a>
          </div>

          <p className="mt-6 text-sm text-cream/50" data-id="element-89">
            Walk-ins welcome • No appointment needed
          </p>
        </motion.div>
      </div>
    </section>;
}